function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Provider } from "../../core/Provider";
import wrapComponent from "../../core/wrapComponent";
import { DefaultTheme, DefaultMapping } from "../../theme";

function ApplicationProvider(props, forwardedRef) {
  const {
    children,
    mapping = DefaultMapping,
    theme = DefaultTheme
  } = props,
        rest = _objectWithoutProperties(props, ["children", "mapping", "theme"]);

  return /*#__PURE__*/React.createElement(Provider, _extends({
    ref: forwardedRef,
    theme: theme,
    mapping: mapping
  }, rest), children);
}

export default wrapComponent(ApplicationProvider, {
  isForwardRef: true
});